'use client'

import {
  inputBase,
  inputDisabled,
  inputError,
  inputFocus,
  inputOutlined,
} from '@/core/constants/class-names'
import { cn } from '@/core/lib/utils/cn'
import { dateService } from '@/core/services/date'
import 'flatpickr/dist/themes/airbnb.css'
import React from 'react'
import Flatpickr, { DateTimePickerHandle } from 'react-flatpickr'
import { createInput } from './input-factory'

type Props = {
  name: string
  value?: Date
  onChange?: (value: string) => void
  onDateChange?: (value: Date) => void
  className?: string
  minDate?: Date | 'today' | number | string
  maxDate?: Date | 'today' | number | string
  error?: string | boolean
  errorMessage?: string
  ref?: React.Ref<DateTimePickerHandle>
}
const BaseDateInput: React.FC<Props> = ({
  name,
  value,
  onChange,
  onDateChange,
  className = '',
  minDate,
  maxDate,
  error,
  errorMessage,
  ref,
  ...rest
}) => {
  const hasError = Boolean(error)
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-1 rounded',
        hasError && inputError,
      )}
    >
      <Flatpickr
        {...rest}
        ref={ref}
        name={name}
        value={value}
        onChange={([date]) => {
          onChange?.(dateService.dateToYyMmDd(date))
          onDateChange?.(date)
        }}
        className={cn(
          'px-1 disabled:cursor-not-allowed',
          inputDisabled,
          inputBase,
          inputFocus,
          inputOutlined,
          className,
        )}
        options={{
          minDate,
          maxDate,
          disableMobile: true,
        }}
      />
      {hasError && errorMessage && (
        <p className='text-red text-sm'>{errorMessage}</p>
      )}
    </div>
  )
}
export const DateInput = createInput(BaseDateInput, ['label'])
export const FormDateInput = createInput(BaseDateInput, ['form', 'label'])
